module.exports = __webpack_public_path__ + "static/submit-grad-ff-11ab00a930b145daf9f08153435f98fb.png";